// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";
import { toggleFiltersWidgetStyles } from "@sc/App/Widgets/ToggleFilters/ToggleFilters";
import Close from "@sc/XDL/Icons/Close";
import { buttonTransparent } from "@sc/XDL/PreStyle/button";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

toggleFiltersWidgetStyles.filtersDrawer = {
    headlineTypographyProps: {
        forwardAs: "p",
        variant: "h4",
        css: css`
            letter-spacing: 0;
            line-height: 22px;
        `,
    },
    closeButtonIconProps: {
        src: Close,
        size: 14,
        color: "primary",
    },
    cssOverrides: {
        scrim: css`
            ${xScreen("lte", "md")} {
                top: 0;
            }
        `,
        drawerTitle: css`
            background: ${color("common.white")};
            padding: 12px 0;
            margin: 0 16px;
            border-bottom: 1px solid ${color("common.border")};
        `,
        headlineTypography: css`
            margin: 0;
        `,
        titleButton: css`
            ${buttonTransparent}
            padding: 8px;
            ${IconWrapper} {
                color: ${color("primary")};
            }
        `,

        drawerBody: css`
            width: 360px;
            background-color: ${color("common.white")};
            ${xScreen("lte", "sm")} {
                top: 0;
                height: 100%;
                width: 100%;
            }
        `,
        drawerContent: css`
            height: 100%;
            overflow-x: hidden;
            padding: 16px;
            margin-bottom: 55px;
            background: ${color("common.white")};
        `,
    },
};

toggleFiltersWidgetStyles.filterBtn = {
    typographyProps: {
        size: 16,
        weight: fontConfig.weight.bold,
        css: css`
            margin-bottom: 0;
            letter-spacing: 0;
            line-height: 19px;
        `,
    },
    icon: {
        iconProps: {
            size: 16,
            src: ChevronDown,
        },
        position: "left",
    },
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: inline-flex;
        }
    `,
};
